import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const catalogEntryListCompareCollectorPriceSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	justifyContent: 'center',
	minHeight: '42px',
	'[data-testid="compare-current-price"]': {
		display: 'flex',
		alignItems: 'center',
	},
	'[data-testid="compare-original-price"]': {
		fontSize: '12px',
		lineHeight: '16px',
		color: 'grey.300',
		textDecoration: 'line-through',
		fontWeight: OpenSansFontWeights.regular,
	},
};

export const catalogEntryListComparePriceRowSX: SxProps = {
	display: 'flex',
	alignItems: 'center',
	gap: '5px',
};

export const catalogEntryListCompareDiscountBadgeSX: SxProps = {
	backgroundColor: 'grey.50',
	color: 'text.highlight',
	fontWeight: OpenSansFontWeights.semibold,
	padding: '2px 5px',
	fontSize: '12px',
	borderRadius: '3px',
};

export const catalogEntryListCompareListPriceSX: SxProps = {
	textDecoration: 'line-through',
	fontSize: '12px',
};
